<template>
  <router-link :to="chatGPTActionDetailLink"
               class="grid grid-cols-5 col-span-5 pt-4 border-solid border-0 border-l-2 pr-3"
               :class="`border-${message.borderColor}`"
               @click.native="selectBubble">
    <ChatGPTActionPlaceholder class="col-span-3 col-start-4" :focus="isSelected"/>
  </router-link>
</template>

<script>
import ChatGPTActionPlaceholder from '@/components/common/ChatGPTActionPlaceholder'

export default {
  name: 'ConversationChatGPTAction',

  components: { ChatGPTActionPlaceholder },

  props: {
    message: {
      type: Object,
      required: true
    },
    selectedBubble: {
      type: Object,
      default: null
    }
  },

  emits: ['bubble-selected'],

  computed: {
    isSelected() {
      return this.selectedBubble && this.selectedBubble.messageId === this.message.id
    },

    chatGPTActionDetailLink() {
      return {
        name: this.$route.name,
        params: this.$route.params,
        query: { ...this.$route.query, messageId: this.message.id, requestId: undefined }
      }
    }
  },

  methods: {
    selectBubble() {
      this.$emit('bubble-selected')
    }
  }
}
</script>
